// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gwtzedkvcnnnlbeidzar.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd3dHplZGt2Y25ubmxiZWlkemFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM5OTA5MTEsImV4cCI6MjA3OTU2NjkxMX0.DyDi6I4oxMPgtAbl5gqlAXepxbJIpkCtJ-4z15kAunI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});